import { useEffect, useState } from 'react'
import { NotificationService } from '../services/notification-service'

export const useNotifications = () => {
  const [status] = useState(NotificationService.getStatus())

  useEffect(() => {
    let isMounted = true

    // NotificationService.initialize()
    //   .then(() => {
    //     if (isMounted) {
    //       setStatus(NotificationService.getStatus())
    //     }
    //   })
    //   .catch((error) => {
    //     console.warn('Notification initialization error:', error)
    //   })

    const updateStatus = () => {
      if (isMounted) {
        //setStatus(NotificationService.getStatus())
      }
    }
    if (typeof window !== 'undefined') {
      window.addEventListener('focus', updateStatus);
    }
    if (typeof document !== 'undefined') {
      document.addEventListener('visibilitychange', updateStatus)
    }
    return () => {
      isMounted = false;
      if (typeof window !== 'undefined') {
        window.removeEventListener('focus', updateStatus);
      }
      if (typeof document !== 'undefined') {
        document.removeEventListener('visibilitychange', updateStatus);
      }
    }
  }, [])

  return status
}

export default useNotifications

